import { fetchAndActivate, getRemoteConfig, getString } from 'firebase/remote-config';
import { create } from 'zustand';
import { secondaryApp } from 'config/firebase';

interface SegmentConfigState {
  config: Record<string, unknown> | null;
  isLoaded: boolean;
  loadConfig: () => Promise<void>;
}

export const useSegmentConfigStore = create<SegmentConfigState>((set) => ({
  config: null,
  isLoaded: false,
  loadConfig: async () => {
    try {
      const remoteConfig = getRemoteConfig(secondaryApp);
      await fetchAndActivate(remoteConfig);
      const entity_profiles = getString(remoteConfig, 'entity_profiles');
      const date_time_range = getString(remoteConfig, 'date_time_range');
      const dateTimeRange = JSON.parse(date_time_range);
      const entityProfile = JSON.parse(entity_profiles);
      Object.keys(dateTimeRange).map((key) => {
        entityProfile[key] = {
          ...entityProfile[key],
          date_time_range: dateTimeRange[key],
        };
      });
      set({ config: entityProfile, isLoaded: true });
    } catch (error) {
      console.warn('Error loading Firebase Remote Config:', error);
      set({ config: null, isLoaded: true });
    }
  },
}));
